import { getTrendingPercentByDateLimit, toDe } from '@/utilites/sku-operations';
import Image from 'next/image';
import SkuDescription from '@/components/skuDescription';
import { IoCaretDown, IoCaretUp } from 'react-icons/io5';
import { SkuEnum } from '@/types/translations/SkuEnum';
import clsx from 'clsx';
import useTypedTranslation from '@/hooks/useTypedTranslation';

type ActivityRowProps = {
  activity: any; // Hier den richtigen Typ verwenden
  skuName: string;
  skuMainImageUrl: string;
  skuBottleSizeInMl: number | null;
  skuVolumeInPercent: number | null;
  skuReleaseDate: string | null;
  skuOrders: any; // Hier den richtigen Typ verwenden
  skuRetailPrice: number;
  translate: (key: SkuEnum) => string;
};

export const ActivityRow = ({
  activity,
  skuName,
  skuMainImageUrl,
  skuBottleSizeInMl,
  skuVolumeInPercent,
  skuReleaseDate,
  translate,
  skuOrders,
  skuRetailPrice,
}: ActivityRowProps) => {
  const trendingPercent = getTrendingPercentByDateLimit(
    skuOrders,
    skuRetailPrice,
    activity.created
  );

  return (
    <tr className="tw-border-0.75 tw-border-l-0 tw-border-r-0 tw-border-t-0 tw-border-solid tw-border-b-custom-gray">
      <td className="tw-w-1/12 tw-py-3">
        <div className="tw-h-20 tw-w-20 tw-rounded-md tw-border-2 tw-border-solid tw-border-custom-gray tw-p-2">
          <Image
            src={skuMainImageUrl}
            alt={skuName}
            width={50}
            height={50}
            className="tw-h-full tw-w-full tw-object-contain"
          />
        </div>
      </td>
      <td className="tw-w-5/12">
        <div className="tw-ml-2 tw-flex tw-flex-col">
          <b className="tw-line-clamp-2 tw-text-textBlack">{skuName}</b>
          <span className="tw-text-sm tw-text-slate-gray">
            <SkuDescription
              skuBottleSizeInMl={skuBottleSizeInMl}
              skuVolumeInPercent={skuVolumeInPercent}
              skuReleaseDate={skuReleaseDate}
            />
          </span>
        </div>
      </td>
      <td className="max-nine:tw-hidden">
        <div className="tw-flex tw-flex-col tw-items-center tw-text-slate-gray">
          <span>{new Date(activity.created).toLocaleDateString()}</span>
          <span>{new Date(activity.created).toLocaleTimeString()}</span>
        </div>
      </td>
      <td className="tw-text-center max-nine:tw-hidden">
        {trendingPercent > 0 ? (
          <div>
            <span className="tw-font-bold tw-text-[#179861]">
              <IoCaretUp />
              {trendingPercent}%
            </span>
          </div>
        ) : trendingPercent < 0 ? (
          <div>
            <span className="tw-font-bold tw-text-[#15253F]">
              <IoCaretDown />
              {trendingPercent}%
            </span>
          </div>
        ) : (
          <div>
            <span className="tw-font-bold tw-text-gray-500">--%</span>
          </div>
        )}
      </td>
      <td className="max-nine:tw-hidden">
        <div className="tw-text-center tw-font-semibold tw-text-text">
          {toDe(activity.value, {
            withSymbol: true,
            withDigits: false,
          })}
        </div>
      </td>
      <td>
        <span
          className={clsx(
            'tw-m-auto tw-flex tw-h-8 tw-w-24 tw-items-center tw-justify-center tw-rounded-xl tw-font-bold max-nine:tw-ml-auto',
            {
              'tw-bg-[#E8EAEC] tw-text-[#15253F]': activity.type === 'ask',
              'tw-bg-[#E8F5F0] tw-text-[#179861]': activity.type === 'bid',
              'tw-bg-[#F3EFE5] tw-text-[#857040]': activity.type === 'order',
            }
          )}
        >
          {translate(`last_activity.${activity.type}` as SkuEnum)}
        </span>
      </td>
    </tr>
  );
};
